import Form from '../__core/Form';
import component from './component.vue';

import api from '@/plugins/api';

export default class FBody extends Form {
  component = component;

  api = api;

  get data() {
    return this.items.reduce((acc, item) => ({
      ...acc,
      ...item.data,
    }), {});
  }

  set data(data) {
    Object.entries(data)
      .forEach(([key, value]) => {
        const item = this.__items.find(i => i.__name === key);
        if (item) {
          item.data = value;
        }
      });
  }

  get() {
    return this.__items
      .reduce((acc, { key, item }) => {
        acc[key] = item.value;
        return acc;
      }, {});
  }

  set(value = {}) {
    Object.keys(value)
      .forEach((key) => {
        const item = this.__items.find(i => i.key === key)?.item;
        if (item) {
          item.set(value[key]);
        }
      });
    return this;
  }

  setItems(items = []) {
    if (Array.isArray(items)) {
      items.forEach(([key, item]) => {
        this.setItem(key, item);
      });
    }
  }

  submit() {
    this.loading = true;
    return super.submit()
      .finally(() => {
        this.loading = false;
      });
  }

  __set(key, value, def) {
    this[key].set(typeof value === 'undefined' ? def : value);
  }
}
